import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import { Rating } from '@spotahome/ui-library';

import './Average.scss';

const AVERAGE_CORRELATIONS = {
  3: 'reviews.reviews-average.good',
  4: 'reviews.reviews-average.very-good',
  5: 'reviews.reviews-average.excellent'
};

const renderAverageTitle = ratingAverage => {
  const averageKey = AVERAGE_CORRELATIONS[ratingAverage];
  return averageKey ? trans(averageKey) : null;
};

const renderAverageTotalText = count =>
  count === 1
    ? trans('reviews.reviews-average.review')
    : trans('reviews.reviews-average.reviews');

const Average = ({ ratingAverage, count }) => (
  <div className="reviews-average">
    <Rating rating={ratingAverage} />
    <h3 className="reviews-average__title">
      {renderAverageTitle(ratingAverage)}
    </h3>
    <span className="reviews-average__total">
      ({count} {renderAverageTotalText(count)})
    </span>
  </div>
);

Average.propTypes = {
  ratingAverage: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired
};

export default Average;
